import Agency from '../../agency';
import Entity from '../../entity';
import Airport from '../airport';

export default class ReservationSearchInput extends Entity<string> {
  bookingDateStarts: string;
  bookingDateEnds: string;
  agency: Agency;
  flightNo: string;
  pnr: string;
  customerFullName: string;
  customerName: string;
  customerSurname: string;
  fromAirport: Airport;
  toAirport: Airport;
  passportNumber: string;
  flightCount: number;
  operationStatus: string;
  status: string;
  orderStatus: number;
  operationStatusOption: Entity<string>;
  orderStatusOption: Entity<string>;
}
